var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading-block"},[_c('h1',{staticClass:"heading",class:{ bordered: _vm.bordered }},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.hasContainer)?_c('div',{staticClass:"container"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }